import React, { useState } from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import FloatingContact from './FloatingContact';
import QuoteModal from './QuoteModal';

const PublicLayout = ({ children }) => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <div className="public-site">
      <PublicHeader onOpenQuote={() => setIsQuoteModalOpen(true)} />
      <main className="public-main">{children}</main>
      <PublicFooter />
      <FloatingContact />
      <QuoteModal isOpen={isQuoteModalOpen} onClose={() => setIsQuoteModalOpen(false)} />
    </div>
  );
};

export default PublicLayout;

